import {
  OrderSortFieldSchema,
  type OrderSortField as GeneratedOrderSortField
} from '~/services/api/generated'

// Mirrors backend App\Enums\Order\OrderSortField

export type OrderSortField = GeneratedOrderSortField

export const OrderSortField = {
  CREATED_AT: OrderSortFieldSchema.enum.created_at,
  REQUESTED_DATE: OrderSortFieldSchema.enum.requested_date,
  REQUESTED_TIME: OrderSortFieldSchema.enum.requested_time
} satisfies Record<string, GeneratedOrderSortField>

export const OrderSortFieldValues: readonly GeneratedOrderSortField[] = [
  OrderSortFieldSchema.enum.created_at,
  OrderSortFieldSchema.enum.requested_date,
  OrderSortFieldSchema.enum.requested_time
]
